import { SiteSizeVsSiteValueChartUnwrapped } from '../../../components/SiteValueCharts/SiteSizeVsSiteValueChart.tsx';
import { Tkv2SiteValueChartsParams } from '../../referenceView/utils/useTkv2SiteValueChartsParams.ts';
import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from './constants.ts';
import { pngChartMaker } from './pngChartMaker.tsx';

export const pngSiteSizeToSiteValueChartMaker = async ({
  siteSizeVsSiteValueChartData,
}: Tkv2SiteValueChartsParams): Promise<string | undefined> =>
  pngChartMaker(SiteSizeVsSiteValueChartUnwrapped, {
    data: siteSizeVsSiteValueChartData,
    disableAnimations: true,
    width: PNG_WIDTH * IMAGE_FACTOR,
    height: PNG_HEIGHT * IMAGE_FACTOR,
  });
